import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import { Layout } from "@/components/site/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";
import { ContentProvider, useContent } from "@/context/ContentContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";

const FullLoader = () => (
  <div className="flex min-h-screen items-center justify-center bg-korio-bg">
    <Loader2 className="animate-spin text-volt" size={32} />
  </div>
);

function ProtectedAdmin() {
  const { user, ready } = useAuth();
  const { loading } = useContent();
  if (!ready || loading) return <FullLoader />;
  if (!user) return <Navigate to="/admin/login" replace />;
  return <AdminDashboard />;
}

function PublicApp() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:slug" element={<ProductDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Layout>
  );
}

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="App">
      <ContentProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedAdmin />} />
              <Route path="/*" element={<PublicApp />} />
            </Routes>
            <Toaster position="bottom-right" theme="dark"
              toastOptions={{ style: { background: "#14243a", border: "1px solid rgba(255,255,255,0.1)", color: "#fff" } }} />
          </BrowserRouter>
        </AuthProvider>
      </ContentProvider>
    </div>
  );
}

export default App;
